module.exports = __webpack_public_path__ + "a2891d5891fd19b3643074b51a47095b.pdf";